// tslint:disable
// this is an auto generated file. This will be overwritten

export const echo = `mutation Echo($test: String) {
  echo(test: $test)
}
`;
export const enroll = `mutation Enroll(
  $courseId: String
  $priceId: String
  $name: String
  $source: String
  $coupon: String
) {
  enroll(
    courseId: $courseId
    priceId: $priceId
    name: $name
    source: $source
    coupon: $coupon
  ) {
    id
    course {
      id
      createdAt
      updatedAt
      slug
      title
      description
      image {
        bucket
        region
        key
      }
      starterFilesLink
      price
      lectures {
        items {
          id
          createdAt
          updatedAt
          title
          video {
            bucket
            region
            key
          }
          directions {
            bucket
            region
            key
          }
          order
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          lectureCourseId
          identityId
        }
        nextToken
      }
      owner
      identityId
      users {
        items {
          id
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          userCourseCourseId
          currency
          source
          amount
          courseId
          invoice
        }
        nextToken
      }
    }
    owner
    userCourseCourseId
    currency
    source
    amount
    courseId
    invoice
  }
}
`;
export const updateUserCourse = `mutation UpdateUserCourse(
  $input: UpdateUserCourseInput!
  $condition: ModelUserCourseConditionInput
) {
  updateUserCourse(input: $input, condition: $condition) {
    id
    course {
      id
      createdAt
      updatedAt
      slug
      title
      description
      image {
        bucket
        region
        key
      }
      starterFilesLink
      price
      lectures {
        items {
          id
          createdAt
          updatedAt
          title
          video {
            bucket
            region
            key
          }
          directions {
            bucket
            region
            key
          }
          order
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          lectureCourseId
          identityId
        }
        nextToken
      }
      owner
      identityId
      users {
        items {
          id
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          userCourseCourseId
          currency
          source
          amount
          courseId
          invoice
        }
        nextToken
      }
    }
    owner
    userCourseCourseId
    currency
    source
    amount
    courseId
    invoice
  }
}
`;
export const deleteUserCourse = `mutation DeleteUserCourse(
  $input: DeleteUserCourseInput!
  $condition: ModelUserCourseConditionInput
) {
  deleteUserCourse(input: $input, condition: $condition) {
    id
    course {
      id
      createdAt
      updatedAt
      slug
      title
      description
      image {
        bucket
        region
        key
      }
      starterFilesLink
      price
      lectures {
        items {
          id
          createdAt
          updatedAt
          title
          video {
            bucket
            region
            key
          }
          directions {
            bucket
            region
            key
          }
          order
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          lectureCourseId
          identityId
        }
        nextToken
      }
      owner
      identityId
      users {
        items {
          id
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          userCourseCourseId
          currency
          source
          amount
          courseId
          invoice
        }
        nextToken
      }
    }
    owner
    userCourseCourseId
    currency
    source
    amount
    courseId
    invoice
  }
}
`;
export const createCourse = `mutation CreateCourse(
  $input: CreateCourseInput!
  $condition: ModelCourseConditionInput
) {
  createCourse(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    slug
    title
    description
    image {
      bucket
      region
      key
    }
    starterFilesLink
    price
    lectures {
      items {
        id
        createdAt
        updatedAt
        title
        video {
          bucket
          region
          key
        }
        directions {
          bucket
          region
          key
        }
        order
        course {
          id
          createdAt
          updatedAt
          slug
          title
          description
          image {
            bucket
            region
            key
          }
          starterFilesLink
          price
          lectures {
            items {
              id
              createdAt
              updatedAt
              title
              order
              owner
              lectureCourseId
              identityId
            }
            nextToken
          }
          owner
          identityId
          users {
            items {
              id
              owner
              userCourseCourseId
              currency
              source
              amount
              courseId
              invoice
            }
            nextToken
          }
        }
        owner
        lectureCourseId
        identityId
      }
      nextToken
    }
    owner
    identityId
    users {
      items {
        id
        course {
          id
          createdAt
          updatedAt
          slug
          title
          description
          image {
            bucket
            region
            key
          }
          starterFilesLink
          price
          lectures {
            items {
              id
              createdAt
              updatedAt
              title
              order
              owner
              lectureCourseId
              identityId
            }
            nextToken
          }
          owner
          identityId
          users {
            items {
              id
              owner
              userCourseCourseId
              currency
              source
              amount
              courseId
              invoice
            }
            nextToken
          }
        }
        owner
        userCourseCourseId
        currency
        source
        amount
        courseId
        invoice
      }
      nextToken
    }
  }
}
`;
export const updateCourse = `mutation UpdateCourse(
  $input: UpdateCourseInput!
  $condition: ModelCourseConditionInput
) {
  updateCourse(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    slug
    title
    description
    image {
      bucket
      region
      key
    }
    starterFilesLink
    price
    lectures {
      items {
        id
        createdAt
        updatedAt
        title
        video {
          bucket
          region
          key
        }
        directions {
          bucket
          region
          key
        }
        order
        course {
          id
          createdAt
          updatedAt
          slug
          title
          description
          image {
            bucket
            region
            key
          }
          starterFilesLink
          price
          lectures {
            items {
              id
              createdAt
              updatedAt
              title
              order
              owner
              lectureCourseId
              identityId
            }
            nextToken
          }
          owner
          identityId
          users {
            items {
              id
              owner
              userCourseCourseId
              currency
              source
              amount
              courseId
              invoice
            }
            nextToken
          }
        }
        owner
        lectureCourseId
        identityId
      }
      nextToken
    }
    owner
    identityId
    users {
      items {
        id
        course {
          id
          createdAt
          updatedAt
          slug
          title
          description
          image {
            bucket
            region
            key
          }
          starterFilesLink
          price
          lectures {
            items {
              id
              createdAt
              updatedAt
              title
              order
              owner
              lectureCourseId
              identityId
            }
            nextToken
          }
          owner
          identityId
          users {
            items {
              id
              owner
              userCourseCourseId
              currency
              source
              amount
              courseId
              invoice
            }
            nextToken
          }
        }
        owner
        userCourseCourseId
        currency
        source
        amount
        courseId
        invoice
      }
      nextToken
    }
  }
}
`;
export const deleteCourse = `mutation DeleteCourse(
  $input: DeleteCourseInput!
  $condition: ModelCourseConditionInput
) {
  deleteCourse(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    slug
    title
    description
    image {
      bucket
      region
      key
    }
    starterFilesLink
    price
    lectures {
      items {
        id
        createdAt
        updatedAt
        title
        video {
          bucket
          region
          key
        }
        directions {
          bucket
          region
          key
        }
        order
        course {
          id
          createdAt
          updatedAt
          slug
          title
          description
          image {
            bucket
            region
            key
          }
          starterFilesLink
          price
          lectures {
            items {
              id
              createdAt
              updatedAt
              title
              order
              owner
              lectureCourseId
              identityId
            }
            nextToken
          }
          owner
          identityId
          users {
            items {
              id
              owner
              userCourseCourseId
              currency
              source
              amount
              courseId
              invoice
            }
            nextToken
          }
        }
        owner
        lectureCourseId
        identityId
      }
      nextToken
    }
    owner
    identityId
    users {
      items {
        id
        course {
          id
          createdAt
          updatedAt
          slug
          title
          description
          image {
            bucket
            region
            key
          }
          starterFilesLink
          price
          lectures {
            items {
              id
              createdAt
              updatedAt
              title
              order
              owner
              lectureCourseId
              identityId
            }
            nextToken
          }
          owner
          identityId
          users {
            items {
              id
              owner
              userCourseCourseId
              currency
              source
              amount
              courseId
              invoice
            }
            nextToken
          }
        }
        owner
        userCourseCourseId
        currency
        source
        amount
        courseId
        invoice
      }
      nextToken
    }
  }
}
`;
export const createLecture = `mutation CreateLecture(
  $input: CreateLectureInput!
  $condition: ModelLectureConditionInput
) {
  createLecture(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    title
    video {
      bucket
      region
      key
    }
    directions {
      bucket
      region
      key
    }
    order
    course {
      id
      createdAt
      updatedAt
      slug
      title
      description
      image {
        bucket
        region
        key
      }
      starterFilesLink
      price
      lectures {
        items {
          id
          createdAt
          updatedAt
          title
          video {
            bucket
            region
            key
          }
          directions {
            bucket
            region
            key
          }
          order
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          lectureCourseId
          identityId
        }
        nextToken
      }
      owner
      identityId
      users {
        items {
          id
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          userCourseCourseId
          currency
          source
          amount
          courseId
          invoice
        }
        nextToken
      }
    }
    owner
    lectureCourseId
    identityId
  }
}
`;
export const updateLecture = `mutation UpdateLecture(
  $input: UpdateLectureInput!
  $condition: ModelLectureConditionInput
) {
  updateLecture(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    title
    video {
      bucket
      region
      key
    }
    directions {
      bucket
      region
      key
    }
    order
    course {
      id
      createdAt
      updatedAt
      slug
      title
      description
      image {
        bucket
        region
        key
      }
      starterFilesLink
      price
      lectures {
        items {
          id
          createdAt
          updatedAt
          title
          video {
            bucket
            region
            key
          }
          directions {
            bucket
            region
            key
          }
          order
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          lectureCourseId
          identityId
        }
        nextToken
      }
      owner
      identityId
      users {
        items {
          id
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          userCourseCourseId
          currency
          source
          amount
          courseId
          invoice
        }
        nextToken
      }
    }
    owner
    lectureCourseId
    identityId
  }
}
`;
export const deleteLecture = `mutation DeleteLecture(
  $input: DeleteLectureInput!
  $condition: ModelLectureConditionInput
) {
  deleteLecture(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    title
    video {
      bucket
      region
      key
    }
    directions {
      bucket
      region
      key
    }
    order
    course {
      id
      createdAt
      updatedAt
      slug
      title
      description
      image {
        bucket
        region
        key
      }
      starterFilesLink
      price
      lectures {
        items {
          id
          createdAt
          updatedAt
          title
          video {
            bucket
            region
            key
          }
          directions {
            bucket
            region
            key
          }
          order
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          lectureCourseId
          identityId
        }
        nextToken
      }
      owner
      identityId
      users {
        items {
          id
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          userCourseCourseId
          currency
          source
          amount
          courseId
          invoice
        }
        nextToken
      }
    }
    owner
    lectureCourseId
    identityId
  }
}
`;
export const createUserCourse = `mutation CreateUserCourse(
  $input: CreateUserCourseInput!
  $condition: ModelUserCourseConditionInput
) {
  createUserCourse(input: $input, condition: $condition) {
    id
    course {
      id
      createdAt
      updatedAt
      slug
      title
      description
      image {
        bucket
        region
        key
      }
      starterFilesLink
      price
      lectures {
        items {
          id
          createdAt
          updatedAt
          title
          video {
            bucket
            region
            key
          }
          directions {
            bucket
            region
            key
          }
          order
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          lectureCourseId
          identityId
        }
        nextToken
      }
      owner
      identityId
      users {
        items {
          id
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          userCourseCourseId
          currency
          source
          amount
          courseId
          invoice
        }
        nextToken
      }
    }
    owner
    userCourseCourseId
    currency
    source
    amount
    courseId
    invoice
  }
}
`;
export const createCoupon = `mutation CreateCoupon(
  $input: CreateCouponInput!
  $condition: ModelCouponConditionInput
) {
  createCoupon(input: $input, condition: $condition) {
    createdAt
    updatedAt
    courseId
    priceId
    numberLeft
    expirationDate
    name
    discountAmount
  }
}
`;
export const updateCoupon = `mutation UpdateCoupon(
  $input: UpdateCouponInput!
  $condition: ModelCouponConditionInput
) {
  updateCoupon(input: $input, condition: $condition) {
    createdAt
    updatedAt
    courseId
    priceId
    numberLeft
    expirationDate
    name
    discountAmount
  }
}
`;
export const deleteCoupon = `mutation DeleteCoupon(
  $input: DeleteCouponInput!
  $condition: ModelCouponConditionInput
) {
  deleteCoupon(input: $input, condition: $condition) {
    createdAt
    updatedAt
    courseId
    priceId
    numberLeft
    expirationDate
    name
    discountAmount
  }
}
`;
